import { render } from "./EditClientPage.vue?vue&type=template&id=baa1ab78"
import script from "./EditClientPage.vue?vue&type=script&lang=js"
export * from "./EditClientPage.vue?vue&type=script&lang=js"

import "@/css/CreateClientPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__